import { useEffect, useRef } from 'react';
import WebSocketService from '../../services/WebSocketService';
import { useGlobalError } from '../../context/GlobalErrorContext';

const WebSocketErrorHandler = () => {
    const { showError, showSuccess } = useGlobalError();
    const hasDisconnectedRef = useRef(false);

    useEffect(() => {
        const handleOpen = () => {
            if (hasDisconnectedRef.current) {
                showSuccess("Connection restored.", {
                    label: "Refresh",
                    onClick: () => window.location.reload()
                });
                hasDisconnectedRef.current = false;
            }
        };

        const handleError = (error) => {
            // "Connection to grading service lost. Trying to reconnect..."
            // We can customize this message.
            hasDisconnectedRef.current = true;
            showError("Connection to server lost. Reconnecting...");
        };

        const handleClose = () => {
             hasDisconnectedRef.current = true;
             showError("Connection to server lost. Reconnecting...");
        };

        WebSocketService.on('open', handleOpen);
        WebSocketService.on('error', handleError);
        WebSocketService.on('close', handleClose);

        return () => {
            WebSocketService.off('open', handleOpen);
            WebSocketService.off('error', handleError);
            WebSocketService.off('close', handleClose);
        };
    }, [showError, showSuccess]);

    return null; // Headless component
};

export default WebSocketErrorHandler;
